export default {
    title:{
        default: 'สิทธิพิเศษของบัตร'
    }
}
